import { MatSelectChange } from "@angular/material";
import { Component, OnInit, Inject } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog
  // MatDialog
} from "@angular/material/dialog";

import * as moment from "jalali-moment";
import { SoundEnum } from "src/app/enums/sound.enum";
// import { IConfirm } from "src/app/interfaces/confirm";
import { TranslateService } from "@ngstack/translate";
import { ILevelInfo } from "src/app/interfaces/levelInfo";
import { ICourseHistory } from "src/app/interfaces/course-history";
import { ErrorsService } from "src/app/services/common/errors.service";
import { IEducationPackage } from "src/app/interfaces/educationPackage";
import { SnackBarService } from "src/app/services/common/snackBar.service";
import { RoomService } from "src/app/services/http/business/room/room.service";
//import { ConfirmComponent } from "src/app/components/confirm/confirm.component";
import { BranchService } from "src/app/services/http/business/branch/branch.service";
import { IDiscountGroupByTermInfo } from "src/app/interfaces/discountGroup-byTermInfo";
import { CourseService } from "./../../../../services/http/business/course/course.service";
import { TermInfoService } from "src/app/services/http/business/term-info/term-info.service";
import { LevelInfoService } from "src/app/services/http/business/levelInfo/level-info.service";
import { StaticValueService } from "src/app/services/http/business/staticValue/static-value.service";
import { CourseHistoryService } from "src/app/services/http/business/course-history/course-history.service";
// import { EducationPackageService } from "src/app/services/http/business/educationPackage/education-package.service";
import { CoursePatternService } from "src/app/services/http/business/course-pattern/course-pattern.service";
import { DiscountGroupService } from "src/app/services/http/business/discount-group/discount-group.service";
import { IConfirm } from "src/app/interfaces/confirm";
import { ConfirmComponent } from "src/app/components/confirm/confirm.component";
import { ExceptionalCoefficientsService } from "src/app/services/http/business/ExceptionalCoefficients/exceptional-coefficients.service";
import { environment } from "src/environments/environment";
// import { PackageEducationBranchComponent } from "../../education-package/package-education-branch/package-education-branch.component";
import { PackageEducationBranchService } from "src/app/services/http/business/packageEducationBranch/package-education-branch.service";
import { IError } from "src/app/interfaces/error.interface";

@Component({
  selector: "app-add-course-entry",
  templateUrl: "./add-course-entry.component.html",
  styleUrls: ["./add-course-entry.component.css"],
  providers: [ErrorsService]
})
export class AddCourseEntryComponent implements OnInit {
  addForm: FormGroup;
  termName: string;
  roomTitle: string;
  room: any;
  branchName: string;
  isAgh: boolean;
  courseTypeName: string;
  levelInfoList: ILevelInfo[];
  eduPackageList: IEducationPackage;
  minDate: any;
  showPrivateAmount: boolean;
  maxDate: any;
  courseTime: any;
  startDate: any;
  hideTeacher: boolean = true;
  hidePicker: boolean = true;
  sexualityName: any;
  //sexualityId: number;
  sexualities: any;
  levelInfoId: number;
  teachersList: any;
  teacherListMain: any;
  coursePatternList = [];
  courseHistoryList: ICourseHistory;
  discountGroupList = [];
  errors = new Array();
  errObject: any;
  param: any;
  errorList: IError[] = [];
  showGender: boolean = false;
  firstDate: any;
  endDate: any;
  levelCapacity: number;
  coefficient = '-----';
  sexualityId: any;

  constructor(
    private fb: FormBuilder,
    private dialog: MatDialog,
    private roomService: RoomService,
    private snackBar: SnackBarService,
    private errorService: ErrorsService,
    public translate: TranslateService,
    private branchService: BranchService,
    private courseService: CourseService,
    private termInfoService: TermInfoService,
    private levelInfoService: LevelInfoService,
    private staticValueService: StaticValueService,
    // private eduPackageService: EducationPackageService,
    private packageEducationBranch: PackageEducationBranchService,
    private courseHistoryService: CourseHistoryService,
    private coursePatternService: CoursePatternService,
    private discountGroupService: DiscountGroupService,
    private exceptionalCoefficientsService: ExceptionalCoefficientsService,
    private dialogRef: MatDialogRef<AddCourseEntryComponent>,

    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }

  ngOnInit() {

    this.getSexuality();
    this.getTermInfo();
    this.getEduPackage();
    this.getStartTime();
    this.getRoom();
    this.getBranch();
    // this.getCourseHistory();
    this.loadCoursePattern();
    this.createForm();
  }

  createForm() {
    this.addForm = this.fb.group({
      et_BranchEncryptId: [this.data.BranchEncryptId],
      et_SexualityId: [null],
      et_RoomId: [this.data.RoomId],
      et_StartDate: [null, Validators.compose([Validators.required])],
      et_TermInfoId: [this.data.TermInfoId],
      et_LevelInfoId: [null, Validators.compose([Validators.required])],
      et_CoursePatternId: [
        this.data.CoursePatternId,
        Validators.compose([Validators.required])
      ],
      CustomerContractId: [this.data.CustomerContractId],
      et_IsPrivate: [this.data.IsPrivate],
      AmountOfUnit: [null],
      //Capacity: [
      //  null,
      //  Validators.compose([
      //    Validators.required,
      //    Validators.min(1),
      //    Validators.max(600)
      //  ])
      //],
      et_EduOrgCapacity: [
        0,
        Validators.compose([
          Validators.required,
          Validators.min(0),
          Validators.max(600)
        ])
      ],
      et_StartTime: [
        this.data.StartTime,
        Validators.compose([Validators.required])
      ],
      et_DiscountGroupId: [null],
      et_CapacityFree: [
        null,
        Validators.compose([
          Validators.required,
          Validators.min(0),
          Validators.max(100)
        ])
      ],
      et_CapacityFreeOnline: [
        null,
        Validators.compose([
          Validators.required,
          Validators.min(0),
          Validators.max(100)
        ])
      ],
      et_TeacherUserEncryptId: [null],
      et_OnlineCourseLink: [null],
      et_IsAsset: [0],
      et_Coefficient: [
        null,
        Validators.compose([
          Validators.required,
          Validators.min(0),
          Validators.max(100)
        ])
      ]
      // et_CourseHistoryId: [null, Validators.compose([Validators.required])],
    });
  }

  getBranch() {

    this.branchService.getById(this.data.BranchEncryptId).subscribe(
      res => {

        this.branchName = res.Name;
        this.isAgh = res.IsAgh;
        // this.addForm.
        // this.checkSexuality(res.SexualityName);
        this.showGender = true;
        this.sexualityName = res.SexualityName;
        // var s = this.sexualities.filter(e => e.Text == sexuality);
        this.sexualityId = res.Sexuality;
        this.addForm.controls["et_SexualityId"].setValue(res.Sexuality.toString());
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  getTermInfo() {

    this.termInfoService.getById(this.data.TermInfoId).subscribe(
      res => {
        this.courseTypeName = res.CourseTypeName;
        this.termName = res.Title;
        this.minDate = moment.from(res.StartDate.toString(), "en");
        this.maxDate = moment.from(res.EndDate.toString(), "en");
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  getRoom() {
    this.roomService.getById(this.data.RoomId).subscribe(
      res => {
        console.log("room");
        console.log(res);

        this.room = res;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  getEduPackage() {
    this.packageEducationBranch.list().subscribe(
      res => {
        this.eduPackageList = res.DataList;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  laodLevel(element: MatSelectChange) {
    this.levelInfoService.getlistByEducationPackageId(element.value).subscribe(
      res => {
        this.levelInfoList = res;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  loadCoursePattern() {
    this.coursePatternService.getList().subscribe(
      res => {
        this.coursePatternList = res.DataList;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  getStartTime() {
    this.courseService.getFirstDate(this.data).subscribe(
      res => {
        this.courseTime = res;
        if (res.DateStart)
          this.firstDate = moment.from(res.DateStart.toString(), "en");
        if (res.EndDate)
          this.endDate = moment.from(res.EndDate.toString(), "en");
      },
      err => {
        // this.errObject = this.errorService.getError(err);
        // this.param = this.errorService.objectError(this.errObject);
        // this.errors = this.errorService.returnError(err);
        this.errorList = this.errorService.getErrorList(err.error);
      }
    );
  }

  onLevelSet(e: MatSelectChange) {
    this.errors = new Array();
    this.hidePicker = false;
    this.levelInfoId = e.value;
    this.levelCapacity = this.levelInfoList.filter(r => r.Id == e.value)[0].MaxCapacity;
    this.addForm.controls["et_EduOrgCapacity"].setValidators(Validators.max(this.levelInfoList.filter(r => r.Id == e.value)[0].MaxCapacity));
    this.addForm.controls["et_EduOrgCapacity"].patchValue(this.levelInfoList.filter(r => r.Id == e.value)[0].MaxCapacity);
    this.addForm.controls["et_CapacityFree"].setValidators(Validators.max(this.levelInfoList.filter(r => r.Id == e.value)[0].MaxCapacity));
    this.addForm.controls["et_CapacityFree"].patchValue(this.levelInfoList.filter(r => r.Id == e.value)[0].MaxCapacity);

    this.addForm.controls["et_CapacityFreeOnline"].setValidators(Validators.max(this.levelInfoList.filter(r => r.Id == e.value)[0].MaxCapacity));
    this.addForm.controls["et_CapacityFreeOnline"].patchValue(this.levelInfoList.filter(r => r.Id == e.value)[0].MaxCapacity);

    var data: IDiscountGroupByTermInfo = {
      LevelInfoId: e.value,
      CoursePatternId: parseInt(this.data.CoursePatternId),
      TimeFrom: this.data.StartTime
    };
    this.discountGroupList = [];
    this.discountGroupService
      .listByLevelInfoAndCoursePattern(data).subscribe(res => {

        this.discountGroupList = res;
      });

    // if (this.courseTime) {
    let coefficientModel = {
      BranchEncryptId: this.data.BranchEncryptId,
      CoursePatternId: parseInt(this.data.CoursePatternId),
      LevelInfoId: e.value,
      TimeStart: this.courseTime ? this.courseTime.StartTime : null,
      TimeEnd: this.courseTime ? this.courseTime.EndTime : null
    };
    this.exceptionalCoefficientsService.getCoefficient(coefficientModel).subscribe(res => {
      this.addForm.controls['et_Coefficient'].setValue(res.TotalCoefficient);
      this.coefficient = res.TotalCoefficient;
    }, () => {
      this.addForm.controls['et_Coefficient'].setValue(2);
      this.coefficient = '2'
      // this.errObject = this.errorService.getError(err);
      // this.param = this.errorService.objectError(this.errObject);
      // this.errors = this.errorService.returnError(err);
    })
    //}


  }

  loadTeacher(date) {
    this.errors = new Array();
    this.hideTeacher = false;
    var data = this.data;
    data.StartDate = moment
      .from(date.value, "en")
      .utc(true)
      .format(environment.dateFormat);
    data.LevelInfoId = this.levelInfoId;
    data.CourseTypeId = data.CourseTypeId;
    this.courseService.GetFreeTeacherInAddEditCourse(data).subscribe(
      res => {
        this.teacherListMain = res;
        this.teachersList = res;
      },
      err => {
        // this.errObject = this.errorService.getError(err);
        // this.param = this.errorService.objectError(this.errObject);
        // this.errors = this.errorService.returnError(err);
        this.errorList = this.errorService.getErrorList(err.error);
      }
    );
  }

  // checkSexuality(sexuality: string) {

  //   if (
  //     sexuality == this.translate.get("label.male") ||
  //     sexuality == this.translate.get("label.female")
  //   ) {
  //     this.showGender = true;
  //     this.sexualityName = sexuality;
  //     var s = this.sexualities.filter(e => e.Text == sexuality);
  //     //this.sexualityId = s[0].Value;
  //   } else {
  //     this.showGender = false;
  //   }
  // }

  getSexuality() {
    this.staticValueService.genderType(false).subscribe(
      res => {
        this.sexualities = res;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  getCourseHistory() {
    this.courseHistoryService.list().subscribe(
      res => {
        this.courseHistoryList = res.DataList;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
  setPrivateAmount(e) {
    this.showPrivateAmount = e.checked;
  }

  filterOptione(key) {
    this.teachersList = this.teacherListMain.filter(function (e) {
      return e.FirstName.includes(key) || e.LastName.includes(key)
    })
  }


  submitCourse(form: any) {
    this.errors = new Array();
    this.courseService.fire();
    form.et_StartDate = moment
      .from(form.et_StartDate, "en")
      .utc(true)
      .format(environment.dateFormat);
    // form.et_CourseDeadLineDate = moment
    //   .from(form.et_StartDate, "en").add(3, 'days')
    //   .utc(true)
    //   .format(environment.dateFormat);
    //form.et_SexualityId = this.sexualityId;

    const model: any = {
      BranchEncryptId: form.et_BranchEncryptId,
      SexualityId: form.et_SexualityId,
      RoomId: form.et_RoomId,
      StartDate: form.et_StartDate,
      TermInfoId: form.et_TermInfoId,
      LevelInfoId: form.et_LevelInfoId,
      CoursePatternId: form.et_CoursePatternId,
      EduOrgCapacity: form.et_EduOrgCapacity,
      StartTime: form.et_StartTime,
      DiscountGroupId: form.et_DiscountGroupId,
      CapacityFree: form.et_CapacityFree,
      CapacityFreeOnline: form.et_CapacityFreeOnline,
      OnlineCourseLink: form.et_OnlineCourseLink,
      TeacherUserEncryptId: form.et_TeacherUserEncryptId,
      IsAsset: form.et_IsAsset,
      Coefficient: form.et_Coefficient,
    };
    if (this.addForm.controls.et_IsPrivate.value) {
      model.IsPrivate = true;
      model.AmountOfUnit = form.AmountOfUnit;
    }
    if (this.isAgh) {
      model.CustomerContractId = form.CustomerContractId;
      model.CustomerContract = {
        AmountOfUnit: form.AmountOfUnit,
        AmountDiscount: 0,
        TaxPercent: 0,
        AmountTransportation: 1,
        MaxCapacity: this.room.Capacity
      }

      this.courseService.AghAdd(model).subscribe(
        () => {
          this.dialogRef.close(model);
          this.snackBar.OpenSnackBar(
            this.translate.get("success.registration"),
            "ok",
            5000,
            SoundEnum.beep
          );
        },
        err => {
          this.errObject = this.errorService.getError(err);
          this.param = this.errorService.objectError(this.errObject);
          this.errors = this.errorService.returnError(err);
          this.errorList = this.errorService.getErrorList(err.error);


          if (this.errors[0] == 13038) {
            let confirm: IConfirm = {
              accept: true,
              message: this.translate.get("serviceErrors.13038", {
                param1: this.param[1]
              }),
              alert: null,
              yesLabel: this.translate.get("label.yes"),
              noLabel: this.translate.get("label.no")
            };
            this.dialog
              .open(ConfirmComponent, {
                width: "250px",
                data: confirm
              })
              .afterClosed()
              .subscribe(res => {
                if (res) {
                  this.errors = new Array();
                  this.courseService.fire();
                  form.StartDate = moment
                    .from(form.StartDate, "en")
                    .utc(true)
                    .format(environment.dateFormat);
                  //form.SexualityId = this.sexualityId;
                  form.RoomCapacity = false;
                  this.courseService.Add(form).subscribe(
                    () => {
                      this.dialogRef.close(form);
                      this.snackBar.OpenSnackBar(
                        this.translate.get("success.registration"),
                        "ok",
                        5000,
                        SoundEnum.beep
                      );
                    },
                    err => {
                      // this.errObject = this.errorService.getError(err);
                      // this.param = this.errorService.objectError(this.errObject);
                      // this.errors = this.errorService.returnError(err);
                      this.errorList = this.errorService.getErrorList(err.error);
                    }
                  );
                }
              });
          }
        }
      );

    }
    else {
      this.courseService.Add(model).subscribe(
        () => {
          this.dialogRef.close(model);
          this.snackBar.OpenSnackBar(
            this.translate.get("success.registration"),
            "ok",
            5000,
            SoundEnum.beep
          );
        },
        err => {
          this.errObject = this.errorService.getError(err);
          this.param = this.errorService.objectError(this.errObject);
          this.errors = this.errorService.returnError(err);
          this.errorList = this.errorService.getErrorList(err.error);


          if (this.errors[0] == 13038) {
            let confirm: IConfirm = {
              accept: true,
              message: this.translate.get("serviceErrors.13038", {
                param1: this.param[1]
              }),
              alert: null,
              yesLabel: this.translate.get("label.yes"),
              noLabel: this.translate.get("label.no")
            };
            this.dialog
              .open(ConfirmComponent, {
                width: "250px",
                data: confirm
              })
              .afterClosed()
              .subscribe(res => {
                if (res) {
                  this.errors = new Array();
                  this.courseService.fire();
                  form.StartDate = moment
                    .from(form.StartDate, "en")
                    .utc(true)
                    .format(environment.dateFormat);
                  // form.SexualityId = this.sexualityId;
                  form.RoomCapacity = false;
                  this.courseService.Add(form).subscribe(
                    () => {
                      this.dialogRef.close(form);
                      this.snackBar.OpenSnackBar(
                        this.translate.get("success.registration"),
                        "ok",
                        5000,
                        SoundEnum.beep
                      );
                    },
                    err => {
                      // this.errObject = this.errorService.getError(err);
                      // this.param = this.errorService.objectError(this.errObject);
                      // this.errors = this.errorService.returnError(err);
                      this.errorList = this.errorService.getErrorList(err.error);
                    }
                  );
                }
              });
          }
        }
      );
    }
  }
}
